import { render, staticRenderFns } from "./DeckCard.vue?vue&type=template&id=193dabc5"
import script from "./DeckCard.vue?vue&type=script&lang=js"
export * from "./DeckCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports